





















































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import { inject } from 'inversify-props';
import { IUserService, UserType, IInvitationService } from '@/interfaces/Services';
import { PatientModel } from '@/models/patient';
import { UserModel } from '@/models/user';
import LambdaDownloader from '@/utils/lambda_downloader';
import DependencyIdentifiers from '@/ioc/DependencyIdentifiers';

type InvitationResult = {
  model: PatientModel;
  err?: Error;
  result?: UserModel;
};

@Component({})
export class PatientInvitationModal extends Vue {
  @inject(DependencyIdentifiers.InvitationService)
  private invitationService!: IInvitationService;

  @Prop({ required: true })
  patients!: PatientModel[];

  private componentKey = 0;
  private current: InvitationResult | null = null;
  private results: InvitationResult[] = [];

  private get progress() {
    if (this.patients.length === 0) {
      return 100;
    }
    return (this.results.length / this.patients.length) * 100;
  }

  private get remaining() {
    return this.patients.length - this.results.length;
  }

  async mounted() {
    const patients = [...this.patients];
    for (let i = 0; i < patients.length; i++) {
      const result: InvitationResult = { model: { ...patients[i] } };
      this.current = result;
      this.componentKey++;
      await new Promise(resolve => setTimeout(resolve, 1500));
      try {
        result.result = await this.invitationService.create({
          type: UserType.Patients,
          name: result.model.name,
          email: result.model.email,
          $patientId: result.model.$id as string,
          $centerId: result.model.$centerId as string,
        });
        this.onInvitationSuccess(result);
      } catch (err) {
        result.err = err;
        this.onInvitationFailure(result);
      } finally {
        this.current = null;
      }
      this.results = [result, ...this.results];
    }
    this.onComplete(this.results);
  }

  @Emit("complete")
  onComplete(result: InvitationResult[]) {
    return result;
  }

  @Emit("invitation:success")
  onInvitationSuccess(result: InvitationResult) {
    this.onInvitation(result);
    return result;
  }

  @Emit("invitation:failure")
  onInvitationFailure(result: InvitationResult) {
    this.onInvitation(result);
    return result;
  }

  @Emit("invitation")
  onInvitation(result: InvitationResult) {
    this.componentKey++;
    return result;
  }

  async downloadRecoveryKey(email: string, recoveryKey: string) {
    const download = new LambdaDownloader(
      {key: recoveryKey, email}, 
      'recovery-key-to-pdf',
      `hemonaplo-recovery-${email}`
    );
    await download.start();
  }
}

export default PatientInvitationModal;
